import { Routes } from 'react-router';

import { withSentryReactRouterV7Routing } from '@sentry/react';

/**
 * This wrapper around RR's Router is a part of Sentry setup for React, see:
 * https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/#usage-with-routes--component
 */
const SentryRoutes = withSentryReactRouterV7Routing(Routes);

export default SentryRoutes;
